import React from 'react'
import { t } from 'i18next'
import { CUSTOMER_DISPLAY_MEDIA_TYPES } from '../constants/customerDisplay.constants'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import FilterSelector from 'Components/FilterSelector'

function CustomerDisplayFilters({
  companies,
  branchOffices,
  selectedCompany,
  selectedBranchOffice,
  selectedMediaType,
  loading,
  onCompanyChange,
  onBranchOfficeChange,
  onMediaTypeChange,
  onClearFilters,
  onCreate,
}) {
  return (
    <div
      className="customer-display-filters"
      data-testid="container-display-filters">
      <Row style={{ width: '100%' }}>
        <Col md={6} lg={3}>
          <FilterSelector
            label={t('CUSTOMER_DISPLAY_SETTINGS.LIST.COMPANY')}
            options={companies}
            getOptionValue={item => item.CompanyId}
            getOptionLabel={item => item.Name}
            value={selectedCompany}
            onChange={event => onCompanyChange(event.CompanyId)}
            disabled={loading}
            placeholder={t('CUSTOMER_DISPLAY_SETTINGS.LIST.COMPANY')}
            testId="company"
          />
        </Col>
        <Col md={6} lg={3}>
          <FilterSelector
            label={t('CUSTOMER_DISPLAY_SETTINGS.LIST.BRANCH_OFFICE')}
            options={branchOffices}
            getOptionValue={item => item.BranchOfficeId}
            getOptionLabel={item => item.Description}
            value={selectedBranchOffice}
            onChange={event => onBranchOfficeChange(event.BranchOfficeId)}
            disabled={loading || !selectedCompany}
            placeholder={t('CUSTOMER_DISPLAY_SETTINGS.LIST.BRANCH_OFFICE')}
            testId="branch-office"
          />
        </Col>
        <Col md={6} lg={3}>
          <FilterSelector
            label={t('CUSTOMER_DISPLAY_SETTINGS.LIST.MEDIA_TYPE')}
            options={CUSTOMER_DISPLAY_MEDIA_TYPES}
            getOptionValue={item => item.value}
            getOptionLabel={item => t(item.label)}
            value={selectedMediaType}
            onChange={event => onMediaTypeChange(event.value)}
            disabled={loading}
            placeholder={t('CUSTOMER_DISPLAY_SETTINGS.LIST.MEDIA_TYPE')}
            testId="media-type"
          />
        </Col>
        <Col
          md={6}
          lg={3}
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '10px',
          }}>
          <button
            data-testid="btn-clear-filters"
            disabled={loading}
            onClick={onClearFilters}
            className="btn-clean">
            {t('CUSTOMER_DISPLAY_SETTINGS.LIST.CLEAR_FILTERS')}
          </button>
          <button
            data-testid="btn-add-customer-display"
            onClick={onCreate}
            className="btn-add">
            {t('CUSTOMER_DISPLAY_SETTINGS.LIST.ADD')}
          </button>
        </Col>
      </Row>
    </div>
  )
}

export default CustomerDisplayFilters
